$(function () {
    
    snackBarInit();
    setTimeout(init, 5000);

    //GA4
    var parameter = customGetUrlParameter("customer_posted");
    if (parameter[0] === "true") {
        var param = window.location.href.split("#")[1];
        if (param === "ContactPopover") {
            pushOtherEvent("gaEvent", "contact", "newsletter", "popOver");
        } else if (param === "ContactFooter") {
            pushOtherEvent("gaEvent", "contact", "newsletter", "footer");
        } else if (param === "ContactEventNewsletter") {
            pushOtherEvent("gaEvent", "contact", "newsletter", "events");
        }
    }

    //END-GA4
})

function snackBarInit(){
    $(document).ready(()=>{
        const snackbar = document.querySelector(".snippet-snackbar.popover");
        if(snackbar){
            snackbar.classList.add("mostra");
        }   
    })
}

function init(){
    if(getCookie("newsletter_cookie")) {
        closeNewsletterPopup();
    } else {
        openNewsletterPopup()
    }
    $(".close-newsletter-popup").on("click", function (evt) {
        setCookie("newsletter_cookie", true);
        closeNewsletterPopup();
    })
}

function setCookie(name, value) {
    var expires = (new Date(Date.now()+ 86400 * 1000 * 7)).toUTCString();
    document.cookie = name + "=" + (value || "") + "; expires=" + expires + "; path=/";
}

function getCookie(name) {
    let cookieName = name + "=";
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) == 0) {
        return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return null;
}

const newsLetterButton = document.querySelector('#newsletterEvent');

$("#newsletterEvent").on("click", function (evt) {
    openNewsletterPopup ();
})

function closeNewsletterPopup () {
    $(".newsletter-popup-container").addClass("hidden");
}

function openNewsletterPopup () {
    $(".newsletter-popup-container").removeClass("hidden");
}

function customGetUrlParameter(sParam) {
    var fullURL = window.location.href;
    let url = new URL(fullURL);
    var allParams = new URLSearchParams(url.search);
    return allParams.getAll(sParam).length !== 0 &&
    allParams.getAll(sParam)[0] !== ""
        ? allParams.getAll(sParam)
        : false;
}